import {
  GETCUSTOMEROWNERDETAILS_SUCCESS,
  GETCUSTOMEROWNERDETAILS_FAILED,
  RESET_GETCUSTOMEROWNERDETAILS,
  LOADING_GETCUSTOMEROWNERDETAILS,
  NETWORK_ERROR_GETCUSTOMEROWNERDETAILS,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETCUSTOMEROWNERDETAILS:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETCUSTOMEROWNERDETAILS_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETCUSTOMEROWNERDETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETCUSTOMEROWNERDETAILS:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETCUSTOMEROWNERDETAILS:
      return (state = initialState);
    default:
      return state;
  }
};
